import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Authorization from "@/authorization";

// Views
import Home from "../views/Home";
import PageNotFound from "../views/PageNotFound";
import Login from "../views/auth/Login";
import RandomChart from "../views/RandomChart";
import FactoryDetails from "../views/FactoryDetails";
import FullMap from "../views/FullMap";
import Preview from "../views/Preview";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: RandomChart,
    meta: {
      //   hasRole: ["Admin", "Super Admin"],
      title: "Dashboard"
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "login"
        });
      }

      next();
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "Login"
    },
    beforeEnter: (to, from, next) => {
      if (store.getters["auth/authenticated"]) {
        return next({
          name: "dashboard"
        });
      }

      next();
    }
  },
  {
    path: "/factorydetails",
    name: "factorydetails",
    component: FactoryDetails,
    meta: {
      title: "Drag Chart"
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "factorydetails"
        });
      }

      next();
    }
  },
  {
    path: "/fullmap",
    name: "fullmap",
    component: FullMap,
    meta: {
      title: "Full Map"
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "login"
        });
      }

      next();
    }
  },
  {
    path: "/preview",
    name: "preview",
    component: Preview,
    meta: {
      title: "Preview"
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({
          name: "login"
        });
      }

      next();
    }
  },
  {
    path: "/not-found",
    name: "not-found",
    component: PageNotFound,
    meta: {
      title: "Page Not Found"
    }
  },
  {
    path: "*",
    redirect: "/not-found"
  }
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // Print Title
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  if (store.getters["auth/authenticated"]) {
    if (to.meta.hasRole && to.meta.hasRole !== "undefined") {
      if (
        Authorization.hasRole(
          store.getters["auth/user"].relationships.roles.data,
          to.meta.hasRole
        ) === true
      ) {
        next();
      } else {
        next({ name: "not-found" });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
